import React, { useState } from 'react';
import axios from 'axios';
import './CahierDesChargesRegie.css';

function CahierDesChargesRegie() {
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [accessCode, setAccessCode] = useState('');
  const [codeError, setCodeError] = useState(false);

  const ACCESS_CODE = '2626';

  const handleCodeSubmit = (e) => {
    e.preventDefault();
    if (accessCode.trim().toUpperCase() === ACCESS_CODE) {
      setIsUnlocked(true);
      setCodeError(false);
    } else {
      setCodeError(true);
    }
  };

  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    telephone: '',
    message: ''
  });
  const [formSent, setFormSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const currentDate = new Date().toLocaleDateString('fr-FR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const icons = {
    target: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
      </svg>
    ),
    user: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
      </svg>
    ),
    phone: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
      </svg>
    ),
    check: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
      </svg>
    ),
    gift: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
      </svg>
    ),
    chart: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
      </svg>
    ),
    award: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="7"/><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
      </svg>
    ),
    rocket: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
      </svg>
    ),
    clock: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
      </svg>
    ),
    clipboard: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
      </svg>
    ),
    info: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
      </svg>
    ),
    handshake: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z"/>
      </svg>
    ),
    dollar: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
    whatsapp: (
      <svg viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
    ),
    send: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
      </svg>
    )
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');

    try {
      await axios.post('/api/candidatures', formData);
      setFormSent(true);
      setFormData({ nom: '', email: '', telephone: '', message: '' });
    } catch (err) {
      console.error('Erreur envoi candidature:', err);
      setError('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setSending(false);
    }
  };

  if (!isUnlocked) {
    return (
      <div className="regie-page">
        <div className="regie-lock-screen">
          <div className="regie-lock-card">
            <div className="regie-lock-icon-container">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="regie-lock-svg">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <div className="regie-lock-logo">E-Shop Pro</div>
            <h2 className="regie-lock-title">Offre Régie Commercial</h2>
            <p className="regie-lock-subtitle">Veuillez entrer le code d'acces pour consulter le Cahier des Charges Régie</p>
            <form onSubmit={handleCodeSubmit} className="regie-lock-form">
              <input
                type="text"
                value={accessCode}
                onChange={(e) => { setAccessCode(e.target.value); setCodeError(false); }}
                placeholder="Code d'acces"
                className={`regie-lock-input ${codeError ? 'regie-lock-input-error' : ''}`}
                autoFocus
                autoComplete="off"
              />
              {codeError && <p className="regie-lock-error-msg">Code incorrect. Veuillez reessayer.</p>}
              <button type="submit" className="regie-lock-btn">Acceder au document</button>
            </form>
            <p className="regie-lock-hint">Vous n'avez pas le code ?</p>
            <div className="regie-lock-buttons">
              <a href="tel:+33743678501" className="regie-lock-call-btn">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="20" height="20">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <span>Appelez-nous</span>
              </a>
              <a href="https://wa.me/33743678501" target="_blank" rel="noopener noreferrer" className="regie-lock-wa-btn">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                <span>WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="regie-page">
      <div className="regie-container">

        {/* HEADER */}
        <div className="regie-header">
          <div className="regie-header-badge">Document Officiel — Régie</div>
          <div className="regie-title-section">
            <div className="regie-logo-container">
              <div className="regie-logo-icon">
                <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="40" height="40" rx="10" fill="rgba(255,255,255,0.2)"/>
                  <path d="M12 14h16M12 20h12M12 26h8" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
                  <circle cx="28" cy="26" r="4" fill="#38bdf8"/>
                </svg>
              </div>
              <span className="regie-logo-text">E-Shop Pro</span>
            </div>
            <h1>Cahier des Charges Régie</h1>
            <p className="regie-subtitle">Solutions digitales & matériel connecté pour les professionnels</p>
          </div>
          <p className="regie-date">Mis à jour le {currentDate}</p>
        </div>

        <div className="regie-content">

          {/* PRODUITS & SERVICES */}
          <section className="regie-section regie-products-section">
            <div className="regie-section-header">
              <span className="regie-section-icon">{icons.clipboard}</span>
              <h2>Produits & Services proposés</h2>
            </div>
            <div className="regie-section-body">
              <p>Vous proposez aux commerçants une gamme complète de solutions digitales et de matériel professionnel :</p>
              <div className="regie-products-grid">

                {/* ECRAN DYNAMIQUE — sans pied, juste l'écran mural */}
                <div className="regie-product-card">
                  <div className="regie-mockup">
                    <div className="mk-screen">
                      <div className="mk-screen-outer">
                        <div className="mk-screen-inner">
                          <div className="mk-screen-slide mk-s1"></div>
                          <div className="mk-screen-slide mk-s2"></div>
                          <div className="mk-screen-slide mk-s3"></div>
                          <div className="mk-screen-overlay"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <strong>Ecrans dynamiques</strong>
                  <p>Affichage dynamique en magasin pour la communication et la promotion</p>
                </div>

                {/* BORNE INTERACTIVE */}
                <div className="regie-product-card">
                  <div className="regie-mockup">
                    <div className="mk-borne">
                      <div className="mk-borne-head">
                        <div className="mk-borne-camera"></div>
                      </div>
                      <div className="mk-borne-display">
                        <div className="mk-borne-nav"></div>
                        <div className="mk-borne-content">
                          <div className="mk-borne-row"></div>
                          <div className="mk-borne-row"></div>
                          <div className="mk-borne-row"></div>
                        </div>
                        <div className="mk-borne-action"></div>
                      </div>
                      <div className="mk-borne-pillar"></div>
                      <div className="mk-borne-foot"></div>
                    </div>
                  </div>
                  <strong>Bornes interactives</strong>
                  <p>Bornes tactiles en point de vente pour l'accueil et la commande</p>
                </div>

                {/* SITE WEB — LAPTOP */}
                <div className="regie-product-card">
                  <div className="regie-mockup">
                    <div className="mk-laptop">
                      <div className="mk-laptop-lid">
                        <div className="mk-laptop-cam"></div>
                        <div className="mk-laptop-display">
                          <div className="mk-browser-top">
                            <span className="mk-dot mk-dot-r"></span>
                            <span className="mk-dot mk-dot-y"></span>
                            <span className="mk-dot mk-dot-g"></span>
                            <div className="mk-url-bar"></div>
                          </div>
                          <div className="mk-page">
                            <div className="mk-page-header"></div>
                            <div className="mk-page-hero"></div>
                            <div className="mk-page-cols">
                              <div className="mk-page-col"></div>
                              <div className="mk-page-col"></div>
                              <div className="mk-page-col"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mk-laptop-bottom">
                        <div className="mk-laptop-kb"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Site web sur mesure</strong>
                  <p>Site internet professionnel adapté à l'activité du client</p>
                </div>

                {/* APPLICATION MOBILE — SMARTPHONE */}
                <div className="regie-product-card">
                  <div className="regie-mockup">
                    <div className="mk-phone">
                      <div className="mk-phone-notch"></div>
                      <div className="mk-phone-display">
                        <div className="mk-app-status"></div>
                        <div className="mk-app-hero-img"></div>
                        <div className="mk-app-title"></div>
                        <div className="mk-app-subtitle"></div>
                        <div className="mk-app-grid">
                          <div className="mk-app-tile"></div>
                          <div className="mk-app-tile"></div>
                          <div className="mk-app-tile"></div>
                          <div className="mk-app-tile"></div>
                        </div>
                        <div className="mk-app-cta"></div>
                      </div>
                      <div className="mk-phone-bar"></div>
                    </div>
                  </div>
                  <strong>Application mobile sur mesure</strong>
                  <p>Application mobile personnalisée pour le commerce du client</p>
                </div>

              </div>
            </div>
          </section>

          {/* TABLEAU DES GAINS */}
          <section className="regie-section regie-gains-section">
            <div className="regie-section-header">
              <span className="regie-section-icon regie-icon-gold">{icons.dollar}</span>
              <h2>Tableau des Gains — Régie Commercial</h2>
            </div>
            <div className="regie-section-body">
              <div className="regie-table-wrapper">
                <table className="regie-table">
                  <thead>
                    <tr>
                      <th>Financement de 36 mois</th>
                      <th>Gain Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><span className="regie-mensualite">99 EUR<small> / mois</small></span></td>
                      <td><span className="regie-gain">700 EUR</span></td>
                    </tr>
                    <tr>
                      <td><span className="regie-mensualite">150 EUR<small> / mois</small></span></td>
                      <td><span className="regie-gain">1 050 EUR</span></td>
                    </tr>
                    <tr>
                      <td><span className="regie-mensualite">199 EUR<small> / mois</small></span></td>
                      <td><span className="regie-gain">1 400 EUR</span></td>
                    </tr>
                    <tr>
                      <td><span className="regie-mensualite">250 EUR<small> / mois</small></span></td>
                      <td><span className="regie-gain">1 750 EUR</span></td>
                    </tr>
                    <tr className="regie-row-highlight">
                      <td><span className="regie-mensualite">299 EUR<small> / mois</small></span></td>
                      <td><span className="regie-gain regie-gain-max">2 100 EUR</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="regie-calcul-note">
                <span className="regie-note-icon">{icons.info}</span>
                <span>Sous réserve d'acceptation de votre dossier par la maison de financement</span>
              </div>
            </div>
          </section>

          {/* CIBLE CLIENT */}
          <section className="regie-section">
            <div className="regie-section-header">
              <span className="regie-section-icon">{icons.target}</span>
              <h2>Cible Client</h2>
            </div>
            <div className="regie-section-body">
              <p>Les entreprises éligibles doivent répondre aux critères suivants :</p>
              <div className="regie-criteria">
                <div className="regie-criteria-item">
                  <span className="regie-criteria-icon">{icons.check}</span>
                  <span>Entreprise immatriculée en France avec un <strong>numéro de SIRET valide</strong></span>
                </div>
                <div className="regie-criteria-item">
                  <span className="regie-criteria-icon">{icons.check}</span>
                  <span>Société en activité depuis <strong>plus d'un an</strong></span>
                </div>
                <div className="regie-criteria-item">
                  <span className="regie-criteria-icon">{icons.check}</span>
                  <span>Le contrat doit être signé par le <strong>gérant ou président</strong> de la société</span>
                </div>
                <div className="regie-criteria-item">
                  <span className="regie-criteria-icon">{icons.check}</span>
                  <span>Engagement sur un <strong>contrat de 36 mois minimum</strong></span>
                </div>
              </div>
              <div className="regie-criteria-note">
                <span className="regie-note-icon">{icons.info}</span>
                <span>Un <strong>contrôle qualité</strong> est effectué sur chaque dossier avant son envoi en maison de financement.</span>
              </div>
            </div>
          </section>

          {/* PROCESSUS */}
          <section className="regie-section regie-avantages-section">
            <div className="regie-section-header">
              <span className="regie-section-icon">{icons.clipboard}</span>
              <h2>Processus de validation</h2>
            </div>
            <div className="regie-section-body">
              <div className="regie-steps">
                <div className="regie-step">
                  <div className="regie-step-number">1</div>
                  <div className="regie-step-text">
                    <strong>Signature du contrat</strong> — Le client s'engage sur un financement de 36 mois
                  </div>
                </div>
                <div className="regie-step">
                  <div className="regie-step-number">2</div>
                  <div className="regie-step-text">
                    <strong>Contrôle qualité</strong> — Le dossier est vérifié avant envoi en maison de financement
                  </div>
                </div>
                <div className="regie-step">
                  <div className="regie-step-number">3</div>
                  <div className="regie-step-text">
                    <strong>Validation & gain</strong> — Une fois le dossier accepté, vous percevez votre commission
                  </div>
                </div>
              </div>
            </div>
          </section>

        </div>

        {/* CONTACT */}
        <section className="regie-section regie-contact-section">
          <div className="regie-section-header">
            <span className="regie-section-icon regie-icon-white">{icons.send}</span>
            <h2>Rejoignez-nous</h2>
          </div>
          <div className="regie-section-body">
            <div className="regie-contact-grid">
              <div className="regie-contact-form-wrapper">
                <h3>Inscription</h3>
                {formSent ? (
                  <div className="regie-form-success">
                    <span className="regie-success-check">{icons.check}</span>
                    <p>Merci ! Nous vous recontacterons rapidement.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="regie-contact-form">
                    {error && <div className="regie-form-error">{error}</div>}
                    <input type="text" name="nom" placeholder="Votre nom" value={formData.nom} onChange={handleInputChange} required disabled={sending} />
                    <input type="email" name="email" placeholder="Votre email" value={formData.email} onChange={handleInputChange} required disabled={sending} />
                    <input type="tel" name="telephone" placeholder="Votre téléphone" value={formData.telephone} onChange={handleInputChange} required disabled={sending} />
                    <textarea name="message" placeholder="Votre message (optionnel)" value={formData.message} onChange={handleInputChange} rows="3" disabled={sending} />
                    <button type="submit" className="regie-btn-submit" disabled={sending}>
                      {sending ? 'Envoi en cours...' : 'Envoyer ma candidature'}
                    </button>
                  </form>
                )}
              </div>

              <div className="regie-contact-info-wrapper">
                <h3>Contact direct</h3>
                <p className="regie-contact-text">Une question ? Contactez-nous directement :</p>
                <div className="regie-contact-buttons">
                  <a href="https://wa.me/33743678501" target="_blank" rel="noopener noreferrer" className="regie-whatsapp-btn">
                    <span className="regie-wa-icon">{icons.whatsapp}</span>
                    <span>WhatsApp</span>
                  </a>
                  <a href="tel:+33743678501" className="regie-phone-btn">
                    <span className="regie-ph-icon">{icons.phone}</span>
                    <span>Appeler</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="regie-footer">
          <div className="regie-footer-logo">E-Shop Pro</div>
          <p>Document officiel — Offre Régie — {currentDate}</p>
          <p className="regie-footer-tagline">Votre partenaire digital de confiance</p>
        </div>
      </div>
    </div>
  );
}

export default CahierDesChargesRegie;
